import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LockIcon from '@mui/icons-material/Lock';
import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import { ChoiceDialogProps } from '../../../components/ChoiceDialog';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { OfferTransferForm } from '../transfer/OfferTransferForm';

export const useCreateHoldingsActions = (
  onClose: () => void,
  selectedRow?: TemplateContract<Holding>,
) => {
  const actions: ChoiceDialogProps['actions'] = [];
  const { party } = useParties();

  if (!selectedRow) {
    return [];
  }
  if (selectedRow.payload.owner === party) {
    if (!selectedRow.payload.lock) {
      actions.push({
        name: 'Transfer',
        form: <OfferTransferForm onClose={onClose} holding={selectedRow} />,
        icon: <CompareArrowsIcon color="inherit" fontSize="small" />,
        variant: 'contained',
      });
    } else {
      actions.push({
        name: 'Locked',
        icon: <LockIcon color="disabled" />,
        disabled: true,
      });
    }
    return actions;
  }
  return actions;
};
